import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';

import { foodSciencesData } from '../../data/departmentalData/foodSciences';

const FoodSciences = () => {
  return <TemplatePage data={foodSciencesData} />;
};

export default FoodSciences;